<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [cmpsTooltipTrigger]="_i18n.__CLOSE_SEARCH | translate"
    (click)="_onToggleSearchClick()"
    *ngIf="_service.state?.searchOpen"
>
    <cmps-icon svgIcon="close"></cmps-icon>
</button>
<div class="cmps-event-centre-search-filter--button-wrapper">
    <button
        class="cmps-event-centre-search-filter--button"
        [class.cmps-event-centre-search-filter--button-active]="
            _service.state?.filterIsDefault?.search === false
        "
        [disabled]="_service.state?.searchOpen"
        [cmpsTooltipTrigger]="_i18n._710_SEARCH | translate"
        (click)="_onToggleSearchClick()"
    >
        <cmps-icon svgIcon="magnify"></cmps-icon>
    </button>
    <div
        class="cmps-event-centre-search-filter--search-input-wrapper"
        *ngIf="_service.state?.searchOpen"
    >
        <input
            [placeholder]="_i18n._710_SEARCH | translate"
            [ngModel]="_service.state?.filterOpts?.keyword ?? ''"
            (ngModelChange)="_onKeywordFilterChange($event)"
            (keydown.enter)="
                $event.preventDefault();
                _dispatchFilterKeyword(searchInputRef.value)
            "
            #searchInputRef
        />
    </div>
    <button
        class="cmps-event-centre-search-filter--button cmps-event-centre-search-filter--button2"
        [class.cmps-event-centre-search-filter--button-active]="
            _service.state?.filterIsDefault?.filter === false
        "
        [cmpsTooltipTrigger]="_i18n._7360_FILTER | translate"
        [cmpsOverlayTrigger]="filterTpl"
    >
        <cmps-icon svgIcon="filter-outline"></cmps-icon>
    </button>
    <button
        class="cmps-event-centre-search-filter--button cmps-event-centre-search-filter--button2"
        [cmpsTooltipTrigger]="_i18n._9468_SORT | translate"
        [cmpsMenuTrigger]="sortMenu"
    >
        <cmps-icon svgIcon="sort-variant"></cmps-icon>
    </button>
</div>

<ng-template
    let-overlay="overlay"
    #filterTpl
>
    <!-- TODO fix uikit auto-close for mouseup (.cmps-event-centre-search-filter--filter) -->
    <cmps-filter
        class="cmps-event-centre-search-filter--filter"
        [overlay]="overlay"
    >
        <cmps-filter-category-header
            >{{ _i18n._127_STATUS | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <cmps-chip-list>
                <ng-container *ngFor="let p of _StatusLabels">
                    <button
                        cmpsChip
                        [value]="p.status"
                        [selected]="
                            _service.state?.filterOpts?.statuses?.includes(
                                p.status
                            )
                        "
                        (click)="_onStatusFilterClick(p.status)"
                    >
                        <span>{{ p.label | translate }}</span>
                    </button>
                </ng-container>
            </cmps-chip-list>
        </cmps-filter-category-body>

        <cmps-filter-category-header
            >{{ _i18n._709_DATE_RANGE | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <cmps-date-range
                [dateRange]="_service.state?.filterOpts?.dateRange"
                fromDatePlacement="bottom-right"
                toDatePlacement="bottom-right"
                (dateRangeChange)="_onDateRangeFilterChange($event)"
            ></cmps-date-range>
        </cmps-filter-category-body>
    </cmps-filter>
</ng-template>

<cmps-menu #sortMenu="cmpsMenu">
    <!-- TODO fix uikit auto-close for mouseup (.cmps-event-centre-search-filter--sort-menu) -->
    <cmps-radio-group
        class="cmps-event-centre-search-filter--sort-menu"
        [value]="_service.state?.orderBy"
        (change)="_onOrderByChange($event)"
    >
        <div class="cmps-cdk-font-bold cmps-cdk-pb-0dot25">
            {{ _i18n._7216_SORT_BY | translate }}
        </div>
        <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
            <cmps-radio [value]="_OrderBy.DATE_DESC">
                {{ _i18n._11212_DATE_NEWEST_FIRST | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.DATE_ASC">
                {{ _i18n._11213_DATE_OLDEST_FIRST | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.USERNAME_ASC">
                {{ _i18n._11214_USER_NAME_ASCENDING | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.USERNAME_DESC">
                {{ _i18n._11215_USER_NAME_DESCENDING | translate }}
            </cmps-radio>
        </div>
    </cmps-radio-group>
</cmps-menu>
